export default __webpack_public_path__ + "static/media/burden.de80a357.png";